import React from "react";
import AntdSwitch, {SwitchProps} from 'antd/lib/switch';
import {withError} from '@fishx/tracker';

interface SProps extends SwitchProps {
    forwardedRef?: any;
};
export const Switch: React.FC<SProps> =(props) => {
    const {forwardedRef, ...rest} = props;
      return (
        <AntdSwitch {...rest} ref ={forwardedRef}/>
      )
  };
  Switch.displayName = 'Switch';
  export default withError(Switch,{
    forwardRef: true,
  });







// WEBPACK FOOTER //
// ./src/components/switch/index.tsx